module.exports = __webpack_public_path__ + "static/media/dark_wall.6fb19d93.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dark_wall.png
// module id = 28
// module chunks = 0